<template>
  <div
    :class="[
      isUser ? 'user-message' : 'system-message',
      { 'w-100' : this.$vuetify.breakpoint.smAndDown }
    ]"
    class="d-flex flex-column message-wrapper"
  >
    <div class="message-bubble">
      <slot name="text-message">
        <vue-markdown class="message-content text-body-1">{{ messageText }}</vue-markdown>

        <v-chip
          v-if="hasAttachmentFile"
          class="mt-2"
          color="grey lighten-4"
          text-color="grey darken-2"
          small
        >
          <v-icon left>
            mdi-attachment
          </v-icon>
          {{ $t('file_attached') }}
        </v-chip>
      </slot>
    </div>
    <div>
      <slot name="message-subtitle">
        <div
          class="message-timestamp"
          :class="{ 'text-right' : isUser }"
        >{{ formatTimestamp(message.timestamp) }}</div>
      </slot>
    </div>
  </div>
</template>

<style scoped>
  .message-wrapper {
    display: flex;
    margin-bottom: 10px;
    max-width: 80%;
  }

  .w-100 {
    max-width: 100%;
  }

  .user-message {
    align-self: flex-end;
    justify-content: flex-end;
  }

  .system-message {
    align-self: flex-start;
  }

  .message-bubble {
    padding: 12px 16px;
    border-radius: 18px;
    position: relative;
  }

  .user-message .message-bubble {
    background-color: #1976d2;
    color: white;
    border-bottom-right-radius: 4px;
  }

  .system-message .message-bubble {
    background-color: #f1f1f1;
    color: #333;
    border-bottom-left-radius: 4px;
  }

  .message-content {
    word-break: break-word;
    margin: 0 !important;
  }

  >>>p {
    margin-bottom: 0 !important;
  }
  
  .message-timestamp {
    font-size: 0.7rem;
    opacity: 0.7;
    margin-top: 1px;
  }
</style>

<script>
  import VueMarkdown from 'vue-markdown';

  import HumanReadable from "@/utils/human_readable";

  export default {
    name: "MessageBubble",

    components: {
      VueMarkdown
    },

    props: {
      message: {
        type: Object,
        default: () => {}
      },

      isUser: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      hasAttachmentFile() {
        return this.message.text.includes("Seguem os dados do Anexo:")
      },

      messageText() {
        if (this.hasAttachmentFile) {
          return this.message.text.replace(/\b(Seguem os dados do Anexo)\b(.*)/, "")
        }

        return (this.message.text)
      }
    },

    methods: {
      formatTimestamp(timestamp) {
        return HumanReadable.epochTimestampToDate(timestamp, true)
      },
    }
  }
</script>
